var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-ranking-container",style:({ width: _vm.width })},[_c('WebpImage',{attrs:{"scale":_vm.scale,"src":_vm.avatar,"width":_vm.width,"height":_vm.height,"radius":_vm.radius}}),(_vm.name)?_c('div',{staticClass:"name",style:({ color: _vm.textColor })},[_vm._v(_vm._s(_vm.name))]):_vm._e(),(_vm.ranking)?_c('span',{class:_vm.self
        ? `ranking-tag ranking-tag-self`
        : `ranking-tag ranking-tag-${_vm.ranking}`},[_vm._v(_vm._s(_vm.ranking))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }